import {
  minimumWidth,
  styled,
  pxToRem,
  Heading,
  Text,
  LinkButton,
} from '@feast-it/ui/light';
import { css } from '@emotion/core';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing[12]} ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      padding: ${theme.spacing[12]} ${theme.spacing[6]};
    }

    ${minimumWidth(theme.breakpoints.medium)} {
      padding: ${theme.spacing[12]} ${theme.spacing[8]};
    }
  `};
`;

export const ContentWrapper = styled.div`
  max-width: ${pxToRem(720)};
  margin: 0 auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledHeading = styled(Heading)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing[6]};
  `};
`;

export const StyledText = styled(Text)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing[4]};
  `};
`;

export const StyledLinkButton = styled(LinkButton)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing[6]};
  `};
`;
